import { createFileRoute } from "@tanstack/react-router";
import { discoverUsersInfiniteQueryOptions } from "~/features/discover/api";
import { DiscoverTemplate } from "~/features/discover/DiscoverTemplate";

export const Route = createFileRoute("/_authenticated/discover/")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureInfiniteQueryData(discoverUsersInfiniteQueryOptions()),
  component: DiscoverTemplate,
});
